function tagsToString(tags) {
  if (!tags) return ''
  if (Array.isArray(tags)) return tags.join(' ')
  return String(tags)
}

export function getDateGate(tags) {
  const m = tagsToString(tags).match(/date-gate-(\d{4}-\d{2}-\d{2})/)
  return m ? m[1] : null
}

export function getLifetimeLimit(tags) {
  const m = tagsToString(tags).match(/lifetime-limit-(\d+)/)
  return m ? Number(m[1]) : null
}

export function todayInLA() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles' }).format(new Date())
}

export function isDateGateAvailable(tags) {
  const gate = getDateGate(tags)
  if (!gate) return true
  return gate === todayInLA()
}

export function isSoldOut(tags, sold) {
  const limit = getLifetimeLimit(tags)
  if (!limit) return false
  return (Number(sold) || 0) >= limit
}
